import React, { useState, useEffect } from "react";
import Password from "./Password";
import ImageGrid from "./ImageGrid";

function App() {
  const [lock, setLock] = useState(true);

  // preload
  // useEffect(() => {
  //   const video = document.createElement('video');
  //   video.src = '/images/image-06-5.md';
  //   video.preload = 'auto';
  //   video.load();
  // }, []);

  if (lock) {
    return <Password setLock={setLock} />;
  }

  return <ImageGrid />;
}

export default App;
